import { invariant } from '~/utils/invariant';

/**
 * Returns the URL for the current environment based on environment variables set by Netlify.
 *
 * @param path The path to append to the URL.
 */
export function getUrl(path: string = '/') {
  let url: string | undefined;

  switch (process.env.CONTEXT) {
    case 'production':
      url = process.env.URL;
      break;
    case 'deploy-preview':
    case 'branch-deploy':
      url = process.env.DEPLOY_PRIME_URL;
      break;
    case 'dev':
      url = `http://localhost:${process.env.PORT || 3000}`;
      break;
  }

  invariant(url, `Invalid url for context "${process.env.CONTEXT}": ${url}`);

  return new URL(path, url);
}
